import { CheckCircleTwoTone, RadioButtonUnchecked } from "@mui/icons-material";
import { FormControlLabel, Radio, styled } from "@mui/material";
import { IListItem } from "../../interface/list-item";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";

interface IOwnProps {
    className?: string;
    option: IListItem;
    onSelect: (checked: boolean) => void;
    isChecked: boolean;
}

const RadioButton = ({
    option,
    onSelect,
    isChecked,
    className,
}: IWithClassName & IOwnProps) => (
    <div className={className}>
        <FormControlLabel
            control={
                <Radio
                    checked={isChecked}
                    onChange={({ target }) => onSelect(target.checked)}
                    icon={
                        <RadioButtonUnchecked className="customCheckboxColor" />
                    }
                    checkedIcon={
                        <CheckCircleTwoTone className="customCheckboxColor" />
                    }
                    className={`checkbox ${className ?? ""}`}
                    disableFocusRipple={true}
                    disableRipple={true}
                    disableTouchRipple={true}
                />
            }
            label={option.name}
        />
    </div>
);
export default styled(RadioButton)(({ theme }: IWithThemeProps) => ({
    ".MuiSvgIcon-root": {
        height: 16,
    },
    ".customCheckboxColor": {
        color: theme?.palette.listsTable.checkBoxColor,
    },
}));
